export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14868.ac3dbe3a.jpg";